// OpenStreetMap standard tiles. Free, but best-effort and with a usage policy:
// https://operations.osmfoundation.org/policies/tiles/
// Keep the url configurable so it can be replaced by a commercial provider.
export const ATTENDANCE_MAP_TILES_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
export const ATTENDANCE_MAP_TILES_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a> contributors';

/** An open session for longer than this is probably a forgotten exit, and not a long shift */
export const ATTENDANCE_OPEN_SESSION_OVERDUE_HOURS = 16;

/** Period of the day of a session, by the hour of its entry */
export type AttendanceDayPeriod = 'morning' | 'afternoon' | 'night';

/** Hour (0-23) when each period starts. The night goes on until the start of the morning. */
export const ATTENDANCE_DAY_PERIOD_START_HOURS: Record<AttendanceDayPeriod, number> = {
  morning: 6,
  afternoon: 14,
  night: 20,
};
